<template>
  <div class="my_search_select_index fk-newLinkPanel">
    <div class="line">
      <div
        class="title"
        v-text="title"
        :style="{width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth}"
      ></div>
      <div class="jz-select jz-select-single f_web_inner_link_item">
        <div
          class="jz-select-selection"
          @click="openDialog"
          ref="search_dialog"
        >
          <span
            class="jz-select-placeholder"
            v-if="getCurName == ''"
            v-text="placeholder"
          ></span>
          <span
            class="jz-select-selected-value"
            v-else
            v-text="getCurName"
          ></span>
          <i
            class="jz-select-arrow"
            :class="dialog_is_show ? 'jz-select-trigger-arrow' : ''"
          ></i>
        </div>
        <div
          class="jz-select-dropdown"
          v-if="dialog_is_show"
        >
          <div
            class="jz_select_filterable_input jz-input-wrapper"
            ref="search_input"
          >
            <input
              type="text"
              v-model="key_word"
              @input="search"
              class="jz-input"
            />
            <i
              class="jz-input-icon"
              @click="clear"
            ></i>
          </div>
          <ul
            class="jz-select-not-found"
            v-if="data_list.length == 0"
          >
            <li>{{$t('components_my_search_select_index_2438')}}</li>
          </ul>
          <ul
            class="jz-select-dropdown-list"
            v-else
          >
            <div class="jz_scrollbar">
              <div
                class="jz_scrollbar__wrap"
                style="height: calc(100% + 6px); max-height: 158px;"
              >
                <div class="jz_scrollbar__resize">
                  <div class="jz_scrollbar__view">
                    <div
                      role="group"
                      v-for="(item,index) in data_list"
                      :key="index"
                    >
                      <li
                        class="jz-select-item"
                        :class="cur_id == item.id ? 'jz-select-item-selected': ''"
                        :title="item.display_name"
                        @click="clickEven(item)"
                        v-text="item.display_name"
                      ></li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_search_select_index',
  props: {
    title: { // 组件的标题
      type: String,
      default: ''
    },
    value: { // 输入框的值
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: { // 数组
      type: Array,
      default: function () {
        return []
      }
    },
    titleWidth: {
      type: Number | String,
      default: 1208
    }
  },
  data () {
    return {
      key_word: '',
      dialog_is_show: false,
      cur_id: 0,
      data_list: this.options,
      select_link: this.value
    }
  },
  mounted () {
    //如果有报错可以写
    this.$nextTick(() => {
      document.addEventListener('click', e => {
        const dom = this.$refs.search_dialog;
        const dom2 = this.$refs.search_input
        if (dom2 && dom && !dom.contains(e.target) && !dom2.contains(e.target)) {
          this.dialog_is_show = false;
          this.$emit('update:value', this.select_link);//双向数据绑定
        }
      });
    });
  },
  beforeDestroy () {
    document.removeEventListener('click', e => {
      this.dialog_is_show = false;
      this.$emit('update:value', this.select_link);//双向数据绑定
    });
  },
  watch: {
  },
  computed: {
    getCurName () {
      let cur_name = ''
      let dataList = this.options
      if (typeof this.select_link.id !== "undefined") {
        dataList.forEach((item) => {
          if (item.id == this.select_link.id) {
            cur_name = item.name
            this.cur_id = item.id
          }
        })
      }
      return cur_name
    }
  },
  methods: {
    clickEven (item) {
      this.cur_id = item.id
      this.select_link = item
      console.log(123, this.select_link)
      this.$emit('update:value', item);//双向数据绑定
      this.dialog_is_show = false
    },
    clear () {
      this.key_word = ''
      this.search()
    },
    search () {
      let temp = []
      let dataList = this.options
      dataList.forEach((item) => {
        if (item.name.indexOf(this.key_word) > -1) {
          temp.push(item)
        }
      })
      this.data_list = temp
    },
    openDialog () {
      this.dialog_is_show = !this.dialog_is_show
      if (this.dialog_is_show) {
        this.clear()
      }
    }
  }
}
</script>

<style scoped>
.jz-select .jz-select-arrow {
  position: absolute;
  top: 0;
  right: 3px;
  display: block;
  width: 25px;
  height: 32px;
  background: url(/static/image/component.png) no-repeat;
  background-position: -136px 14px;
  transition: transform 0.3s;
}
.fk-newLinkPanel {
  position: relative;
  display: inline-block;
}
.jz_select_filterable_input .jz-input + .jz-input-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 100%;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
  background: 0;
}
.jz-input-wrapper .jz-input-icon {
  position: absolute;
  right: 0;
  width: 32px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
  background: url(/static/image/component.png) no-repeat -378px 9px;
}
.line {
  height: 32px;
  line-height: 32px;
  padding-top: 2px;
  clear: both;
}
.title {
  font-size: 13px;
  color: #333;
  font-family: 微软雅黑, serif;
  width: 95px;
  margin-right: 8px;
  line-height: 32px;
  float: left;
  text-align: right;
}
.f_web_inner_link_item {
  float: left;
  width: 252px;
}
.jz-select {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  color: #333;
  font-size: 13px;
  font-family: 微软雅黑, serif;
  width: 250px;
}
.jz-select-single .jz-select-selection .jz-select-selected-value {
  display: block;
  height: 32px;
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  padding-right: 20px;
}
.jz-select-single .jz-select-selection {
  position: relative;
  height: 32px;
}
.jz-select-selection {
  position: relative;
  display: block;
  outline: 0;
  user-select: none;
  cursor: pointer;
  border-radius: 2px;
  border: 1px solid #e3e2e8;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
}
.jz-select-dropdown {
  position: absolute;
  width: inherit;
  margin: 8px 0;
  padding: 5px 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.14);
  z-index: 2;
}
.jz_select_filterable_input {
  display: block;
  margin: 5px;
}
.jz-input-wrapper {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  pointer-events: auto;
}
.jz-select-dropdown ul {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
}
.jz-select-not-found {
  color: #ccc;
  text-align: center;
  font-size: 13px;
}
ol,
ul {
  list-style: none;
}
li {
  float: left;
  width: 87px;
  margin: 0 5px 10px 0;
}
.jz-select-dropdown ul {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
}
.jz-select-dropdown-list {
  font-size: 13px;
}
.jz_scrollbar {
  overflow: hidden;
  position: relative;
  height: 100%;
}
.jz_scrollbar__wrap {
  position: relative;
  height: 100%;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.jz_scrollbar__resize {
  position: relative;
}
.f_web_inner_link_item .jz-select-item {
  padding-left: 10px !important;
  text-align: left;
}
.jz-select-item {
  position: relative;
  margin: 2px 5px !important;
  line-height: normal;
  padding: 6px 0 !important;
  clear: both;
  color: #333;
  white-space: nowrap;
  list-style: none;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  float: none;
  width: auto;
  text-indent: 0;
}
.jz_scrollbar__view {
  position: relative;
}
.f_web_inner_link_item .jz-select-item {
  padding-left: 10px !important;
  text-align: left;
}
.jz-select-item-selected,
.jz-select-item:hover {
  color: #fff;
  background: #5874d8;
}
.f_web_inner_link_item .jz-select-item {
  padding-left: 10px !important;
  text-align: left;
}
.jz-select .jz-select-trigger-arrow {
  transform: rotate(180deg);
}
.jz-select .jz-select-arrow {
  position: absolute;
  top: 0;
  right: 3px;
  display: block;
  width: 25px;
  height: 32px;
  background: url(/static/image/component.png) no-repeat;
  background-position: -136px 14px;
  transition: transform 0.3s;
}
.jz_select_filterable_input {
  display: block;
  margin: 5px;
}
.jz-input-wrapper {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  pointer-events: auto;
}
.jz_select_filterable_input .jz-input {
  display: block;
  width: 240px;
  height: 30px;
}
.jz-input {
  width: 240px;
  height: 34px;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid #e3e2e8;
  background-color: #fff;
  font-size: 13px;
  font-family: 微软雅黑, serif;
  color: #333;
  padding: 0 8px;
  text-overflow: ellipsis;
}
.jz_select_filterable_input .jz-input + .jz-input-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 100%;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
  background: 0;
}
.jz-input-wrapper .jz-input-icon {
  position: absolute;
  right: 0;
  width: 32px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
  background: url(/static/image/component.png) no-repeat -378px 9px;
}
.jz_select_filterable_input .jz-input + .jz-input-icon:after {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  background: url(/static/image/component.png) no-repeat -386px 0;
}
.jz-input-wrapper:hover .jz-input,
.jz-input:focus {
  border-color: #5874d8;
  outline: 0;
}
.jz_select_filterable_input .jz-input:focus + .jz-input-icon:after {
  background-position: -411px 1px;
}
.jz_select_filterable_input .jz-input + .jz-input-icon:after {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  background: url(/static/image/component.png) no-repeat -386px 0;
}
.jz-select-single .jz-select-selection .jz-select-placeholder,
.jz-select-single .jz-select-selection .jz-select-selected-value {
  display: block;
  height: 32px;
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  padding-right: 20px;
}
.jz-select-single .jz-select-selection .jz-select-placeholder {
  color: #999;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_search_select/index.vue